import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '@shared/APIEndpoint';
import { BaseApiService } from './base-api-service';
import { AppConsts } from '@shared/AppConsts';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CheckSerialRequest, CheckSerialResponse, CommonImportAgrs, FileDto, GetSellOutDistributorInput, PagedResultDtoOfGetSellOutDistributorForViewDto, RemoveSerialResponse, ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem, ReturnSerialRequest, ReturnSerialResponse, SAP1Doi1SerialLoiInputDto, ScanSerialRequestDto, StatusImportDistributeDto, UpdateDONumberRequest, UpdateDONumberResponse } from '@shared/service-proxies/service-proxies';
import * as moment from '@node_modules/moment/moment';

@Injectable({ providedIn: 'root' })
export class WarehouseSaleService extends BaseApiService {
        protected prefix = AppConsts.warehousePrefix;

        constructor(api: ApiService, protected http: HttpClient) {
                super(api);
        }

        updateDONumber(
                input: UpdateDONumberRequest
        ): Observable<UpdateDONumberResponse> {

                const url = API_ENDPOINTS.Warehouse.Sales.UpdateDONumber;

                return this.put<UpdateDONumberResponse>(url, input);
        }

        isDistributorRole(): Observable<string> {
                const url = API_ENDPOINTS.Warehouse.Products.IsDistributorRole;

                return this.post<string>(url, {});
        }

        getAllSellOutDistributor(input: GetSellOutDistributorInput | null | undefined): Observable<PagedResultDtoOfGetSellOutDistributorForViewDto> {
                const url = API_ENDPOINTS.Warehouse.Sales.GetAllSellOutDistributor;

                return this.post<PagedResultDtoOfGetSellOutDistributorForViewDto>(url, input);
        }

        returnOrExchangeSerial(
                input: ReturnSerialRequest
        ): Observable<ReturnSerialResponse> {
                const url = API_ENDPOINTS.Warehouse.Sales.ReturnOrExchangeSerial;

                return this.post<ReturnSerialResponse>(url, input);
        }


        insertSerialAll(
                input: ScanSerialRequestDto[] | null | undefined
        ): Observable<StatusImportDistributeDto> {

                const param = {
                        LstInput: input,
                        lst_input: input
                };
                const url = API_ENDPOINTS.Warehouse.Sales.InsertSerialAll;

                return this.post<StatusImportDistributeDto>(url, param);
        }

        checkSerial(
                input: CheckSerialRequest | null | undefined
        ): Observable<CheckSerialResponse> {

                const url = API_ENDPOINTS.Warehouse.Sales.CheckSerial;

                return this.post<CheckSerialResponse>(url, input);
        }

        insertSerialNotInSystem(
                serial?: string | null,
                modelCode?: string | null
        ): Observable<CheckSerialResponse> {

                const url = API_ENDPOINTS.Warehouse.Sales.InsertSerialNotInSystem;

                const params: any = {};
                if (serial != null) params.serial = serial;
                if (modelCode != null) params.modelCode = modelCode;

                return this.post<CheckSerialResponse>(url, params);
        }

        importQueueDistribute(arg: CommonImportAgrs): Observable<StatusImportDistributeDto> {
                const url = API_ENDPOINTS.Warehouse.Sales.ImportQueueDistribute;

                return this.post<StatusImportDistributeDto>(url, arg);
        }


        importQueueDistributeReturn(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
                const url = API_ENDPOINTS.Warehouse.Sales.ImportQueueDistributeReturn;

                return this.post<StatusImportDistributeDto>(url, arg);
        }

        callPortal1Doi1SerialLoiAsync(
                input?: SAP1Doi1SerialLoiInputDto | null
        ): Observable<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem> {
                return this.post<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem>(
                        API_ENDPOINTS.Warehouse.Sales.CallPortal1Doi1SerialLoiAsync,
                        input
                );
        }

        removeSerialNotInSystem(
                serial?: string | null
        ): Observable<RemoveSerialResponse> {
                return this.delete<RemoveSerialResponse>(
                        API_ENDPOINTS.Warehouse.Sales.RemoveSerialNotInSystem,
                        { serial }
                );
        }


        downloadTempFile(
                fileName?: string,
                fileType?: string,
                fileToken?: string
        ): Observable<Blob> {
                const url = API_ENDPOINTS.File.DownloadTempFile;

                let params = new HttpParams();
                if (fileName != null) params = params.set("FileName", fileName);
                if (fileType != null) params = params.set("FileType", fileType);
                if (fileToken != null) params = params.set("FileToken", fileToken);

                return this.getBlob(url, params);
        }

        getFileExcelSummaryProduct(fromDate?: moment.Moment | null, toDate?: moment.Moment | null): Observable<FileDto> {
                const params: any = {};
                if (fromDate) {
                        params.fromDate = fromDate.toISOString();
                }
                if (toDate) {
                        params.toDate = toDate.toISOString();
                }

                return this.get(API_ENDPOINTS.Warehouse.Sales.GetFileExcelSummaryProduct, params);
        }
        getFileExcelSummarySerial(
                referenceId?: string | null,
                salemanCode?: string | null,
                fromDate?: moment.Moment | null,
                toDate?: moment.Moment | null,
                memberCode?: string | null,
                serial?: string | null,
                model?: string | null,
                vehicleNumber?: string | null,
                saleType?: string | null,
                serialType?: string | null,
                isDistributorTemp?: boolean | null,
                sorting?: string | null,
                skipCount?: number | null,
                maxResultCount?: number | null
        ): Observable<FileDto> {

                const params: any = {};

                if (referenceId) params.ReferenceId = referenceId;
                if (salemanCode) params.SalemanCode = salemanCode;
                if (fromDate) params.FromDate = fromDate.toISOString();
                if (toDate) params.ToDate = toDate.toISOString();
                if (memberCode) params.MemberCode = memberCode;
                if (serial) params.Serial = serial;
                if (model) params.Model = model;
                if (vehicleNumber) params.VehicleNumber = vehicleNumber;
                if (saleType) params.SaleType = saleType;
                if (serialType) params.SerialType = serialType;
                if (isDistributorTemp !== null && isDistributorTemp !== undefined)
                        params.IsDistributorTemp = isDistributorTemp;
                if (sorting) params.Sorting = sorting;
                if (skipCount !== null && skipCount !== undefined)
                        params.SkipCount = skipCount;
                if (maxResultCount !== null && maxResultCount !== undefined)
                        params.MaxResultCount = maxResultCount;

                return this.get<FileDto>(
                        API_ENDPOINTS.Warehouse.Sales.GetFileExcelSummarySerial,
                        params
                );
        }

        getSaleHistoryForExport(
                fromDate?: moment.Moment | null,
                toDate?: moment.Moment | null
        ): Observable<FileDto> {

                const params: any = {};

                if (fromDate) {
                        params.fromDate = fromDate.toISOString();
                }

                if (toDate) {
                        params.toDate = toDate.toISOString();
                }

                return this.get<FileDto>(
                        API_ENDPOINTS.Warehouse.Sales.GetSaleHistoryForExport,
                        params
                );
        }

        getFileExcelSAPSync(
                fromDate?: moment.Moment | null,
                toDate?: moment.Moment | null
        ): Observable<FileDto> {

                const params: any = {};

                if (fromDate) {
                        params.fromDate = fromDate.toISOString();
                }

                if (toDate) {
                        params.toDate = toDate.toISOString();
                }

                return this.get<FileDto>(
                        API_ENDPOINTS.Warehouse.Sales.GetFileExcelSAPSync,
                        params
                );
        }

        getFileExcelSerialInput(
                fromDate?: moment.Moment | null,
                toDate?: moment.Moment | null
        ): Observable<FileDto> {

                const params: any = {};

                if (fromDate) {
                        params.fromDate = fromDate.toISOString();
                }

                if (toDate) {
                        params.toDate = toDate.toISOString();
                }

                return this.get<FileDto>(
                        API_ENDPOINTS.Warehouse.Sales.GetFileExcelSerialInput,
                        params
                );
        }

        getFileExcelSerialInputDetail(
                fromDate?: moment.Moment | null,
                toDate?: moment.Moment | null
        ): Observable<FileDto> {

                const params: any = {};

                if (fromDate) {
                        params.fromDate = fromDate.toISOString();
                }

                if (toDate) {
                        params.toDate = toDate.toISOString();
                }

                return this.get<FileDto>(
                        API_ENDPOINTS.Warehouse.Sales.GetFileExcelSerialInputDetail,
                        params
                );
        }

        getFileExcelHistory(
                fromDate?: moment.Moment | null,
                toDate?: moment.Moment | null,
        ): Observable<FileDto> {

                const params: any = {};

                if (fromDate) {
                        params.fromDate = fromDate.toISOString();
                }

                if (toDate) {
                        params.toDate = toDate.toISOString();
                }

                return this.get<FileDto>(
                        API_ENDPOINTS.Warehouse.Sales.GetFileExcelHistory,
                        params
                );
        }
}
